import type { Timeframe } from '@shared/types/candle'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import type { ActiveIndicator, ChartType } from '@/types/chart'

export interface ChartTemplate {
  id: string
  name: string
  chartType: ChartType
  timeframe: Timeframe
  indicators: Omit<ActiveIndicator, 'instanceId'>[]
  createdAt: number
}

interface TemplateStore {
  templates: ChartTemplate[]
  saveTemplate: (name: string, data: Omit<ChartTemplate, 'id' | 'createdAt' | 'name'>) => void
  deleteTemplate: (id: string) => void
  renameTemplate: (id: string, name: string) => void
}

export const useTemplateStore = create<TemplateStore>()(
  persist(
    immer((set) => ({
      templates: [],

      saveTemplate: (name, data) =>
        set((s) => {
          s.templates.push({ ...data, id: crypto.randomUUID(), name, createdAt: Date.now() })
        }),

      deleteTemplate: (id) =>
        set((s) => {
          s.templates = s.templates.filter((t) => t.id !== id)
        }),

      renameTemplate: (id, name) =>
        set((s) => {
          const t = s.templates.find((t) => t.id === id)
          if (t) t.name = name
        }),
    })),
    { name: 'mhp-templates' }
  )
)
